<div class="row flex-between-center border my-2">
  <div class="col-auto">
    <labeled-content [label]="'instrumentForm.nominalInterestRate'">
      <label class="data-labels">{{ financialAsset().interestRate }}</label>
    </labeled-content>
  </div>
  <div class="col-auto">
    <labeled-content [label]="'instrumentForm.startOfPayingInterest'">
      <label class="data-labels">{{
        financialAsset().start | date : "yyyy.MM.dd"
      }}</label>
    </labeled-content>
  </div>
  <div class="col-auto">
    <labeled-content [label]="'instrumentForm.interestPaymentFrequenty'">
      <label class="data-labels">{{ financialAsset().payFrequency }}</label>
    </labeled-content>
  </div>
  <div class="col-auto">
    <labeled-content [label]="'general.expirationDate'">
      <label class="data-labels">{{
        financialAsset().end | date : "yyyy.MM.dd"
      }}</label>
    </labeled-content>
  </div>
  <div class="col-auto">
    <labeled-content [label]="'instrumentForm.applicableYield'">
      <label class="data-labels">{{ financialAsset().applicableReturn }}</label>
    </labeled-content>
  </div>
</div>
